export const calendarsFallbackConfig = {
    config: {
        calendar_types_section_headings: {
            heading: 'Calendars for every space',
            subHeading: 'From cubicles to kitchens, keep track of important dates wherever you are'
        },
        calendars_sku_mappings: 'calendars_sku_mappings_cs',
        dc_batch_1: {
            marquee: 'calendars_marquee_cs',
            marquee_side_panel: 'calendars_marquee_side_panel_cs',
            two_up_section: 'calendars_two_up_section_cs',
            standalone_contents: 'calendars_standalone_contents_cs',
            calendar_types_section: [
                'calendars_types_part_1_cs',
                'calendars_types_part_2_cs'
            ],
            promo_wells: 'calendars_promo_wells_cs'
        }
    }
};
